import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDateTime, asLabel, createdByField, field, lastModifiedByField, lookup, type Row, text, urlField } from './kit';

const def = OBJECT_DEFS.deliverables;

/** One deal document produced from a quote (0105). Rationale: deliverables.md. */
export const deliverables: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Deliverable',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('deliverable_type_name', 'Type', { link: lookup('deliverable-types', 'deliverable_type_id') }),
    field('quote_name', 'Quote', { link: lookup('quotes', 'quote_id') }),
    field('opportunity_name', 'Opportunity', { link: lookup('opportunities', 'opportunity_id') }),
    field('project_name', 'Project', { link: lookup('projects', 'project_id') }),
    field('version', 'Version'),
    field('status', 'Status', { format: asLabel }),
    urlField('artifact_url', 'Artifact URL'),
    field('document_name', 'Document', { link: lookup('documents', 'document_id') }),
    field('owner_name', 'Owner', { link: lookup('people', 'owner_id') }),
    field('is_exemplar', 'Exemplar', { format: asCheck, help: 'The quote builder imitates exemplars of its type.' }),
    field('exemplar_note', 'Exemplar Note', { wide: true, help: 'What makes it worth imitating.' }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['deliverable_type_name', 'quote_name', 'opportunity_name', 'project_name', 'version', 'status', 'artifact_url', 'document_name', 'owner_name'] },
    { key: 'exemplar', label: 'Exemplar', fields: ['is_exemplar', 'exemplar_note'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'deliverable_type_name', 'quote_name', 'opportunity_name'],
};
